<template>
  <!-- 全局消息提示框 -->
  <!-- <div v-show="visible" class="dialog-tips dialog-center" :class="styleObject">
        <div>{{message}}</div>
  </div>-->
  <transition name="fade">
    <div :class="getClass" class="message" v-if="message && visible">{{message}}</div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      visible: true, // 是否显示
      message: "", // 消息
      msgType: "info", // 消息类型 默认info   'success','error','info','warning'
    };
  },
  computed: {
    styleObject () {
      return "message-" + this.msgType
    },
    getClass () {
      switch (this.msgType) {
        case 'info':
          return 'message-info'
        case 'success':
          return 'message-success'
        case 'error':
          return 'message-error'
        case 'warning':
          return 'message-warning'
        default:
          break
      }
    }
  }
};
</script>
<style scoped lang="scss">
.message {
  position: fixed;
  padding: 4% 5%;
  top: 0%;
  left: 0%;
  background-color: rgba(250, 199, 0, 0.9);
  text-align: center;
  border-radius: 0.3em;
  right: 0;
  margin: 0 auto;
  width: 40%;
  z-index: 9999;
}
// .fade-leave-active {
//   margin-top: -20%;
//   transition: margin-top 3s ease-in-out;
//   -moz-transition: margin-top 3s ease-in-out; /* 火狐4 */
//   -webkit-transition: margin-top 3s ease-in-out; /* 谷歌 */
//   -o-transition: margin-top 3s ease-in-out; /* Opera */
// }
.fade-enter-active,
.fade-leave-active {
  // margin-top: 0;
  transition: margin-top 0.8s;
}
.fade-enter,
.fade-leave-to {
  margin-top: -20%;
}

.dialog-tips {
  position: absolute;
  z-index: 100;
  min-width: 220px;
  padding: 10px 22px 10px 22px;
  white-space: nowrap;
  -webkit-box-shadow: 0px 8px 15px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0px 8px 15px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-top: 42px;
  width: 30%;
  white-space: normal;
  background-color: #edf2fc;
  border-color: #ebeef5;
  color: #909399;
}
.dialog-center {
  top: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.message-info {
  background-color: rgba(250, 199, 0, 0.9);
  border-color: #ec8d07;
  color: #130d03;
}
.message-success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}
.message-error {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
}
.message-warning {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
}
</style>



// WEBPACK FOOTER //
// src/components/toast/toast.vue